$(document).ready(function() {
  $('.icon-slider').slick({
		rows: 2,
		dots: false,
		arrows: true,
		infinite: true,
		speed: 300,
		slidesToShow: 3,
		slidesToScroll: 3
});


$(".slider-gallery").slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
arrows:true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll:1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  $('.slider-gallery').on('beforeChange', function() {
    $('.image-gallery-items').removeClass("aos-animate");
}).on('afterChange', function(event, slick, currentSlide) {
    $('.image-gallery-items').addClass("aos-animate");
    
});
  

$(".featured-block-reviews").slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  autoplay: true,
  autoplaySpeed: 4000,
arrows:true,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll:2
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll:1,
        arrows:false,
        dots:true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  $(".featured-pdpSlider").slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  autoplay: false,
  autoplaySpeed: 4000,
 adaptiveHeight: true,
arrows:false,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll:2
      }
    },
    {
      breakpoint: 549,
      settings: {
        slidesToShow: 1,
        slidesToScroll:1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$(".accordion_head").click(function() {
          var find_parent=$(this).closest(".single-line-data");
          var topClass=find_parent.parent(".pdp-bottom-section");
           
           if (!topClass.hasClass("openTab")) {
			$(".pdp-bottom-section").removeClass("openTab");
		}
         topClass.toggleClass("openTab");
         
          
         });
$(".button-part button").click(function(){ 
  var find_targetLink= $(this).attr("data-id");
         $('html, body').animate({
              scrollTop: $("#"+find_targetLink).offset().top
        }, 'slow');               
    });


  $(".btn-target-section").click(function(e){ 
    e.preventDefault();
  var find_targetLink= $(this).attr("data-id");
         $('html, body').animate({
              scrollTop: $("#"+find_targetLink).offset().top
        }, 'slow');               
    });
});
//  $('.atc-btn').click(function(e){
// console.log('hdbch');
//           var variant_id = $(this).parent().find('input').val();
//           var data = {
//             "id": variant_id,
//             "quantity": 1
//           }
//           jQuery.ajax({
//             type: 'POST',
//             url: '/cart/add.js',
//             data: data,
//             dataType: 'json',
//             success: function() {
//                window.location.href = '/cart';
//             }
//           });
//  })
function fbpixelATC(pdtitle, pdcategory, pdid, pdprice, shopcurrency){

     fbq('track', 'AddToCart',{
        content_name: pdtitle,
        content_type: 'product_group',
        content_category: pdcategory ,
        content_ids: pdid,
        value: pdprice ,
        currency: shopcurrency
    });
}